import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BusyIndicatorService {


  private processCount = 0;

  public get isBusy(): boolean {
    return this.processCount > 0;
  }

  constructor() { }

  beginProcess() {
    this.processCount++;
    console.log(`beginProcess: ${this.processCount}`);
  }

  endProcess() {
    this.processCount--;
    console.log(`endProcess: ${this.processCount}`);
  }

}
